import { Input } from "antd";
import React, { FC, useState } from "react";
import AppHeader from "../../shared/components/AppHeader";
import ButtonComponent from "../../shared/components/ButtonComponent";
import CKEditorComponent from "../../shared/components/CKEditorComponent";
import "./generator.scss";

const Generator: FC = () => {
  const [userInput, setUserInput] = useState<string>("");
  const [convertedInput, setConvertedInput] = useState<string>("");
  return (
    <div className="page-view">
      <AppHeader
        headerText="Generator"
        showBreadCrumb={false}
        showFilter={false}
        showSearch={false}
        showButton={false}
      />
      <div className="generator__container">
        <CKEditorComponent
          value={userInput}
          onChange={(value) => setUserInput(value)}
        />
        <div className="generator__controllers">
          <ButtonComponent
            type="text"
            buttonContent="Clear"
            onClick={() => {
              setUserInput("");
              setConvertedInput("");
            }}
          />
          <ButtonComponent
            type="primary"
            buttonContent="Convert"
            onClick={() => setConvertedInput(userInput)}
          />
        </div>
        <div className="info"><span>*</span> Hit <span>Convert</span> to see the results</div>
        <div className="label">Result:</div>
        <Input.TextArea
          value={convertedInput}
          disabled={!convertedInput}
          className="generator__textarea"
        />
      </div>
    </div>
  );
};

export default Generator;
